import N8nCommandBar from './CommandBar.vue';

export default N8nCommandBar;
